const d =
	'm52-34 217-607 393 389L52-34Zm534-400-45-45 227-227q36-36 92.5-36.5T954-707l17 17-46 45-19-19q-19-19-44.5-19.5T817-664L586-434ZM404-611l-45-46 25-26q24-23 22.5-52T384-785l-28-28 46-45 26 26q39 40 38.5 99T427-634l-23 23Zm93 88-46-45 143-143q19-19 18.5-48.5T593-808l-61-61 46-46 63 63q35 37 36 92.5T642-668L497-523Zm181 182-46-46 43-42q40-40 95.5-41t95.5 39l51 51-46 46-52-52q-23-23-48-23t-48 23l-45 45Z';

export default d;
